import { ComputeFeasibilityParams } from '@ps/survey-utils';

import { FeasibilityPayloadMapper } from '../../feasibility/mappers/feasibility.payload.mapper';
import { PurePriceCpiRequestDto } from '../dtos/pure-price-cpi.dto';

/**
 * Builds the pure-price-cpi request by reusing the feasibility payload — the
 * pure price is priced off the same audience inputs, so the quota/qualification
 * wire shapes are shared rather than re-derived. Only the outer envelope
 * (abbreviated keys) differs. Pricing/grouping/supplier fields the feasibility
 * payload also carries are irrelevant here and dropped.
 */
export class PurePriceCpiPayloadMapper {
  private readonly _feasibilityPayloadMapper = new FeasibilityPayloadMapper();

  public toPayload(params: ComputeFeasibilityParams): PurePriceCpiRequestDto {
    const { payload } = this._feasibilityPayloadMapper.build(params);

    return {
      N: payload.completes_required,
      gpp: { LOI: payload.expected_loi, IR: payload.expected_ir },
      fldTime: payload.field_time,
      clickBalance: payload.click_balancing,
      estmClicks: payload.estimated_clicks,
      quotas: payload.quotas,
      qualifications: payload.defaultQuota[0]?.criteria ?? [],
    };
  }
}
